import { NAME } from './constants';

export const LOGIN = `${NAME}/LOGIN`;
export const LOGOUT = `${NAME}/LOGOUT`;
export const LOGIN_FINISH = `${NAME}/LOGIN_FINISH`;
